
export const hexToRGBA = (hex, alpha) => {
  let r = 0,
    g = 0,
    b = 0;

  if (hex.length === 4) {
    r = "0x" + hex[1] + hex[1];
    g = "0x" + hex[2] + hex[2];
    b = "0x" + hex[3] + hex[3];
  } else if (hex.length === 7) {
    r = "0x" + hex[1] + hex[2];
    g = "0x" + hex[3] + hex[4];
    b = "0x" + hex[5] + hex[6];
  }
  return `rgba(${+r},${+g},${+b},${alpha})`;
};

export const shapesForDrawLine = {
  line1: {
    cam1: { x: 450, y: 250, width: 2, height: 250 },
    cam2: { x: 455, y: 245, width: 2, height: 250 },
    cam3: { x: 460, y: 240, width: 2, height: 250 },
    cam4: { x: 465, y: 235, width: 2, height: 250 },
    cam5: { x: 470, y: 230, width: 2, height: 250 },
    cam6: { x: 475, y: 225, width: 2, height: 250 },
    color: "blue",
  },
  line2: {
    cam1: { x: 450, y: 200, width: 250, height: 2 },
    cam2: { x: 455, y: 205, width: 250, height: 2 },
    cam3: { x: 460, y: 210, width: 250, height: 2 },
    cam4: { x: 465, y: 215, width: 250, height: 2 },
    cam5: { x: 470, y: 220, width: 250, height: 2 },
    cam6: { x: 475, y: 225, width: 250, height: 2 },
    color: "green",
  },
  rectangle: {
    cam1: { x: 580, y: 250, width: 40, height: 250 },
    cam2: { x: 590, y: 260, width: 40, height: 250 },
    cam3: { x: 600, y: 270, width: 40, height: 250 },
    cam4: { x: 610, y: 280, width: 40, height: 250 },
    cam5: { x: 620, y: 290, width: 40, height: 250 },
    cam6: { x: 630, y: 300, width: 40, height: 250 },
    color: "gray",
  },
  pitchingBall: {
    cam1: { x: 600, y: 300, width: 10, height: 10 },
    cam2: { x: 900, y: 450, width: 10, height: 10 },
    cam3: { x: 300, y: 500, width: 10, height: 10 },
    cam4: { x: 630, y: 330, width: 10, height: 10 },
    cam5: { x: 900, y: 450, width: 10, height: 10 },
    cam6: { x: 320, y: 498, width: 10, height: 10 },
    color: "red",
  },
  impactBall: {
    cam1: { x: 620, y: 320, width: 10, height: 10 },
    cam2: { x: 850, y: 450, width: 10, height: 10 },
    cam3: { x: 320, y: 500, width: 10, height: 10 },
    cam4: { x: 650, y: 350, width: 10, height: 10 },
    cam5: { x: 900, y: 490, width: 10, height: 10 },
    cam6: { x: 300, y: 500, width: 10, height: 10 },
    color: "white",
  },
};
